var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "56px",
    viewBox: "0 0 49 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.8760557%",
    y1: "83.7378561%",
    x2: "7.54328547%",
    y2: "83.7378561%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.9880813,3.00470827 L7.20674828,47.2776324 L7.20674828,47.2776324 L24.2298184,47.2776324 L41.2754226,47.2776324 L28.4940896,3.00470827 C27.9803441,1.22515883 26.3514558,1.56926544e-13 24.4992326,1.53714079e-13 L23.9829382,1.53714079e-13 C22.1307151,1.55830683e-13 20.5018267,1.22515883 19.9880813,3.00470827 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.8%",
    y: "-6.3%",
    width: "117.6%",
    height: "112.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.194329108 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.7073598%",
    y1: "0%",
    x2: "15.8814258%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "71.7073598%",
    y1: "0%",
    x2: "15.8814258%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.079,54.8415689 L46.4032391,54.8415689 C47.5514391,54.8415689 48.4822391,53.9107689 48.4822391,52.7625689 L48.4822391,49.2021827 C48.4822391,48.0539827 47.5514391,47.1231827 46.4032391,47.1231827 L2.079,47.1231827 C0.930800005,47.1231827 3.03475265e-16,48.0539827 0,49.2021827 L0,52.7625689 C7.47999262e-17,53.9107689 0.930800005,54.8415689 2.079,54.8415689 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.1%",
    y: "-25.9%",
    width: "108.3%",
    height: "151.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.566597465 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Financial-Results",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Results-AA-Copy-4",
    transform: "translate(-483.000000, -529.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(443.000000, 529.534960)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(39.847137, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(0.237186, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "15.0820052 19.998788 33.399756 19.998788 30.3542519 9.44876824 18.1281921 9.44876824"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "12.3540257 29.4476928 36.1277355 29.4476928 39.1739224 39.9977126 9.30920448 39.9977126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.56747,3.302425 L11.040418,47.6479589 C10.7689869,48.7913711 11.4758672,49.9383283 12.6192794,50.2097594 C12.7803076,50.2479854 12.9452458,50.2672942 13.110749,50.2672942 L13.5497067,50.2672942 C14.8623525,50.2672942 15.9950389,49.3466109 16.263232,48.061655 L25.6028059,3.3142602 C25.7854324,2.43926737 25.2241586,1.58189749 24.3491658,1.39927099 C24.240405,1.37657068 24.1295958,1.36513003 24.0184913,1.36513003 C22.8513484,1.36513003 21.837043,2.16684021 21.56747,3.302425 Z",
    id: "Fill-1",
    fillOpacity: 0.4,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#515151",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.8335345,54.8415689 L11.5587462,54.8415689 L11.5587462,54.8415689 C11.0253393,54.5815367 10.7654148,54.2803567 10.7789729,53.9380287 C10.7993099,53.4245367 10.7955107,48.8565807 10.7789729,48.1285318 C10.7679477,47.6431658 11.0278721,47.3080495 11.5587462,47.1231827 L7.8335345,47.1231827 C6.68533451,47.1231827 5.7545345,48.0539827 5.7545345,49.2021827 L5.7545345,52.7625689 C5.7545345,53.9107689 6.68533451,54.8415689 7.8335345,54.8415689 Z",
    id: "Combined-Shape",
    fillOpacity: 0.4,
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConeIcon);
export default __webpack_public_path__ + "static/media/cone-icon.b96c60d9a07f3d8b89cf9ad6a8660bb3.svg";
export { ForwardRef as ReactComponent };